export type DocumentDateViewMode = 'jours' | 'mois' | 'annees';

export interface DocumentDateFilterState {
    viewMode: DocumentDateViewMode;
    dateFilterStart: string;
    dateFilterEnd: string;
    selectedDay: string;
    selectedMonthIndex: number | null;
    selectedYear: number | null;
}

const STORAGE_KEY = 'vente_document_date_filter';

export function loadDocumentDateFilter(): DocumentDateFilterState | null {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) {
            return null;
        }
        const parsed = JSON.parse(raw) as Partial<DocumentDateFilterState>;
        if (!parsed.dateFilterStart || !parsed.dateFilterEnd) {
            return null;
        }
        return {
            viewMode: parsed.viewMode === 'mois' || parsed.viewMode === 'annees' ? parsed.viewMode : 'jours',
            dateFilterStart: String(parsed.dateFilterStart),
            dateFilterEnd: String(parsed.dateFilterEnd),
            selectedDay: String(parsed.selectedDay || parsed.dateFilterStart),
            selectedMonthIndex:
                parsed.selectedMonthIndex === null || parsed.selectedMonthIndex === undefined
                    ? null
                    : Number(parsed.selectedMonthIndex),
            selectedYear:
                parsed.selectedYear === null || parsed.selectedYear === undefined
                    ? null
                    : Number(parsed.selectedYear),
        };
    } catch {
        return null;
    }
}

export function saveDocumentDateFilter(state: DocumentDateFilterState): void {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch {
        /* quota / mode privé */
    }
}
